import { render, staticRenderFns } from "./invoiceDetails.vue?vue&type=template&id=038d3bdb&scoped=true&"
import script from "./invoiceDetails.vue?vue&type=script&lang=js&"
export * from "./invoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDetails.vue?vue&type=style&index=0&id=038d3bdb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d3bdb",
  null
  
)

component.options.__file = "invoiceDetails.vue"
export default component.exports